interface Clock {
  now(): number;
  heard(serverTime: string): void;
}

export function createClock(deviceNow: () => number): Clock {
  let offset = 0;
  return {
    now: () => deviceNow() + offset,
    heard(serverTime) {
      const server = Date.parse(serverTime);
      if (!Number.isNaN(server)) offset = server - deviceNow();
    },
  };
}
